<script setup lang="ts" name="ShipmentsCountIcon">
import BaseCircle from '~/components/BaseCircle.vue';

defineProps<{
  value: number;
  isFullValue?: boolean;
  isOpen?: boolean;
}>();
</script>

<template>
  <BaseCircle
    size="md"
    border="solid"
    color="primary"
    background="transparent"
    disabled
    :hoverable="!isOpen"
    :number="value"
    :isFullNumber="isFullValue"
  />
</template>
